// Copyright (c) 2019 Deere & Company

import { Alert } from '../state/alert';
import actions from '../actions-list';

const getTypeOfAlerts = alerts => alerts && alerts.length > 0 && alerts[0].type;

const addErrorAlerts = ( state, action ) => {

    const newAlerts = action.messages.map( message => new Alert( message ) );

    if ( getTypeOfAlerts( newAlerts ) !== getTypeOfAlerts( state ) ) {

        return newAlerts;

    }

    return [...state, ...newAlerts];

};

const addSuccessAlerts = ( state, action ) => action.messages.map(
    message => new Alert( message ),
);

const discardAlerts = () => [];

export default ( state = [], action = {} ) => {

    const actionTypes = {
        [actions.ADD_ERROR_ALERT_MESSAGE]: addErrorAlerts,
        [actions.DISCARD_ALERT_MESSAGES]: discardAlerts,
        [actions.ADD_SUCCESS_ALERT_MESSAGE]: addSuccessAlerts,
    };

    const reducer = actionTypes[action.type];

    return reducer ? reducer( state, action ) : state;

};
